import createEditDashboardRedux from 'Modules/dashboard/views/.components/dashboardPanel/.components/createEditDashboard/redux/reducer';
import gadgetChartRedux from 'Modules/dashboard/views/.components/chart/.components/forms/createEditChart/redux/reducer';
import dashboardPanelMainRedux from 'Modules/dashboard/views/.components/dashboardPanel/redux/reducer';
import deleteDashboardRedux from 'Modules/dashboard/views/.components/dashboardPanel/.components/deleteDashboard/redux/reducer';
import deleteChartRedux from 'Modules/dashboard/views/.components/chart/.components/deleteChart/redux/reducer';
import vidFleetClipRequestsDetailsRedux from 'Modules/dashboard/views/.components/dashboardPanel/.components/vidFleetClipRequestsDetails/redux/reducer';
import firmwareDetailsRedux from 'Modules/dashboard/views/.components/dashboardPanel/.components/firmwareDetails/redux/reducer';
import devicesByStatusRedux from 'Modules/dashboard/views/.components/chart/.components/devicesByStatus/redux/reducer';
import lastReadingDetailsRedux from 'Modules/dashboard/views/.components/dashboardPanel/.components/lastReadingDetails/redux/reducer';
import maintenanceWarningsDetailsRedux from 'Modules/dashboard/views/.components/dashboardPanel/.components/maintenanceWarningsDetails/redux/reducer';
import shareDashboardRedux from 'Modules/dashboard/views/.components/dashboardPanel/.components/shareDashboard/redux/reducer';
//export redux objects
export default {
	createEditDashboardRedux,
	gadgetChartRedux,
	dashboardPanelMainRedux,
	deleteDashboardRedux,
	deleteChartRedux,
	vidFleetClipRequestsDetailsRedux,
	firmwareDetailsRedux,
	devicesByStatusRedux,
	lastReadingDetailsRedux,
	maintenanceWarningsDetailsRedux,
	shareDashboardRedux,
};